/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Notes_Not_SupportedInputs */

const en_api_error_task_notes_not_supported = /** @type {(inputs: Api_Error_Task_Notes_Not_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This activity does not accept notes or observations.`)
};

const pt_br2_api_error_task_notes_not_supported = /** @type {(inputs: Api_Error_Task_Notes_Not_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta atividade não aceita notas ou observações.`)
};

/**
* | output |
* | --- |
* | "This activity does not accept notes or observations." |
*
* @param {Api_Error_Task_Notes_Not_SupportedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_notes_not_supported = /** @type {((inputs?: Api_Error_Task_Notes_Not_SupportedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Notes_Not_SupportedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_notes_not_supported(inputs)
	return pt_br2_api_error_task_notes_not_supported(inputs)
});